module.exports = __webpack_public_path__ + "static/img/Banner01.a3cd55a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Banner01.jpg
// module id = 283
// module chunks = 2